module.exports = __webpack_public_path__ + "static/media/lens_outline.261aeea0.svg";